export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11332.1d8dabfd.jpg";